import { render, staticRenderFns } from "./EmptyPanel.vue?vue&type=template&id=d2578732&scoped=true&"
import script from "./EmptyPanel.vue?vue&type=script&lang=js&"
export * from "./EmptyPanel.vue?vue&type=script&lang=js&"
import style0 from "./EmptyPanel.vue?vue&type=style&index=0&id=d2578732&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2578732",
  null
  
)

export default component.exports